<template>
  <v-sheet class="item" color="#FBF9F4" width="100%">
    <LoadingWidget v-if="loading" class="py-16" />

    <transition name="fade">
      <template v-if="!loading">
        <v-container class="py-8 py-md-12 py-lg-16">
          <v-breadcrumbs :items="breadcrumbs" class="mb-6">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :to="item.to" :exact="item.exact">
                <span class="font-secondary">
                  {{ item.text }}
                </span>
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>

          <v-row align="center" justify="center">
            <v-col cols="12" sm="6">
              <div
                v-if="xs"
                class="primary--text text-h3 text-md-h2 text-center"
              >
                {{ item.title }}
              </div>

              <ImagesTypeProductItemTemplate
                v-if="images && images.featuredImg"
                class="mt-3 mt-md-5 mt-lg-7 mb-6 mb-md-0"
                v-bind="images"
              />
            </v-col>

            <v-col cols="12" sm="6">
              <div v-if="!xs" class="primary--text text-h3 text-md-h2">
                {{ item.title }}
              </div>

              <div v-if="item.price" class="text-h6 font-weight-light">
                <span class="font-secondary">
                  {{ formatPrice(item.price) }}
                </span>
              </div>

              <div v-if="whatsapp" class="text-center text-sm-left mt-7">
                <v-btn
                  class="text-body-1 font-weight-medium white--text px-14"
                  :href="`${getWhatsappLinkFromPhone(
                    whatsapp
                  )}?text=${whatsappText}`"
                  target="_blank"
                  color="#25d366"
                  height="52px"
                  depressed
                  rounded
                >
                  <v-icon size="28" class="mr-3"> fa-whatsapp </v-icon>
                  <span class="font-secondary"> SOLICITAR ORÇAMENTO </span>
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="item.text">
            <v-col cols="12">
              <div
                class="
                  mt-8
                  px-6 px-md-8
                  py-8 py-sm-10 py-md-12 py-lg-14
                  item-text
                "
              >
                <div class="text-h6 text-md-h5 primary--text font-weight-bold">
                  <span class="font-secondary"> Descrição </span>
                </div>
                <div
                  class="
                    grey--text
                    text--darken-2 text-body-1
                    mt-3 mt-md-4
                    ck-content
                  "
                >
                  <span class="font-secondary" v-html="item.text"></span>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </transition>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import ImagesTypeProductItemTemplate from "../components/templates/ImagesTypeProductItemTemplate.vue";
import { formatToURL } from "../utils/formatToURL";
import { formatPrice } from "../utils/formatPrice";
import { getWhatsappLinkFromPhone } from "../utils/getWhatsappLinkFromPhone";

const _config = {
  mod: "products",
};

export default {
  data: () => ({
    loading: true,
    item: {},
    images: {},
    breadcrumbs: [],
  }),
  computed: {
    whatsapp() {
      return this.$rest("informations").item.whatsapp_shop;
    },
    whatsappText() {
      return (
        encodeURIComponent("Olá, ví e gostei do produto ") +
        this.files +
        this.$route.fullPath
      );
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;

          let featuredImg = null;

          if (data.img && data.img.featured && data.img.featured.path)
            featuredImg = this.files + data.img.featured.path;

          const gallery = [];

          if (data.img && data.img.list && data.img.list.length > 1)
            data.img.list.map(({ path }) => {
              gallery.push(this.files + path);
            });

          this.images = {
            featuredImg: featuredImg,
            list: gallery,
          };

          this.breadcrumbs = [
            {
              text: "Produtos",
              exact: true,
              to: "/produtos",
            },
          ];

          if (data.category)
            this.breadcrumbs.push({
              text: data.category.title,
              exact: true,
              to: `/produtos?categoria=${formatToURL(data.category.title)}-${
                data.category.id
              }`,
            });

          if (data.subcategory)
            this.breadcrumbs.push({
              text: data.subcategory.title,
              exact: true,
              to: `/produtos?subcategoria=${formatToURL(
                data.subcategory.title
              )}-${data.subcategory.id}`,
            });

          this.breadcrumbs.push({
            text: data.title,
            exact: true,
            to: `/produtos/${this.$route.params.item}`,
          });
        })
        .then(() => (this.loading = false))
        .catch(() => this.$router.replace("/error404"));
    },
    formatPrice,
    getWhatsappLinkFromPhone,
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    LoadingWidget,
    ImagesTypeProductItemTemplate,
  },
};
</script>

<style lang="scss" scoped>
.item-text {
  border: 1px solid #dddddd;
}
</style>
